<script setup lang="ts">
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import BankingTransactionsWorkspace from '@/views/Banking/Transactions/BankingTransactionsWorkspace.vue'

definePage({
  meta: { ...PageMeta.Banking.Transactions.Meta, pageTitle: PageMeta.Banking.Transactions.Title },
})
</script>

<template>
  <BankingTransactionsWorkspace />
</template>
